import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /**
     * Custom portal target. Prefer `[role="dialog"]` or omit (body) — do not portal
     * into panels with `overflow-hidden` ancestors or the content will clip.
     */
    container?: HTMLElement | null;
    /**
     * Keep natural width (e.g. wide date picker). Skips Radix available-width shrinking
     * that clips content inside `overflow-hidden` modals; popover may extend past edges.
     */
    unconstrained?: boolean;
  }
>(({ className, align = "center", sideOffset = 4, container, unconstrained = false, ...props }, ref) => (
  <PopoverPrimitive.Portal container={container ?? undefined}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      collisionPadding={8}
      className={cn(
        "z-50 rounded-md border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        unconstrained
          ? "w-max max-w-[calc(100vw-2rem)] overflow-visible p-0"
          : "w-72 max-w-[min(calc(100vw-2rem),var(--radix-popover-content-available-width))] max-h-[min(calc(100dvh-2rem),var(--radix-popover-content-available-height))] overflow-auto p-4 text-popover-foreground",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
